<template>
  <Select
    :items="opcoes"
    :selectedItem="filter.comDuimpAssociada"
    :label="filtro.name"
    searchPlaceholder="Buscar opção"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';

export default {
  components: {
    Select
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filtroExclusivo: 'com_di_associada',
      filter: {
        comDuimpAssociada: {
          id: '',
          name: ''
        }
      },
      opcoes: [
        { id: 'true', name: 'Sim' },
        { id: 'false', name: 'Não' }
      ]
    };
  },
  computed: {
    valorAplicado() {
      return this.$store.state.filtroAplicados[this.filtro.filtro];
    }
  },
  watch: {
    valorAplicado(valor) {
      if (!valor) {
        this.filter.comDuimpAssociada = { id: '', name: '' };
      }
    }
  },
  methods: {
    atualizar(opcao) {
      this.filter.comDuimpAssociada = opcao;

      if (opcao.id === '') {
        this.$removeFiltroDaURL(this.filtro.filtro, this.path);
        this.$store.commit('removeFiltroAplicado', this.filtro.filtro);
        return;
      }

      if (opcao.id === 'true') {
        this.limparFiltroExclusivo();
      }

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.comDuimpAssociada.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.comDuimpAssociada.id
      });
    },
    limparFiltroExclusivo() {
      if (this.$store.state.filtroAplicados[this.filtroExclusivo] !== 'true') return;

      this.$removeFiltroDaURL(this.filtroExclusivo, this.path);
      this.$store.commit('removeFiltroAplicado', this.filtroExclusivo);
    }
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.opcoes, this.filter.comDuimpAssociada);
  }
}
</script>
